import {Service} from '../../service/service.js';
import {UnitService} from '../../service/unit/unitService.js';
import {ElementUtil} from '../../utils/elementUtil.js';
import {TimeUtil} from '../../utils/timeUtil.js';
import {StringUtil} from '../../utils/stringUtil.js'

export var TractorTools = {
	
	jurisdictions: function(options){
		var jurisWin = ElementUtil.create({
			tag: 'dl-dialog',
			title: 'Jurisdictions',
			icon: 'vaadin:globe',				
			width: .75,
			height: .75,
			listeners: {
				ready: function() {						
					jurisWin.show();	
										
					var toolbar = ElementUtil.create({
						tag: 'dl-toolbar',
						slot: 'toolbar',
						theme: 'spacing',
						children: [							
							{
								tag: 'dl-action-button',
								itemid: 'add',
								theme: 'primary',
								'class': 'spacer-toolbar-item',
								permissions: ['TRACTOR_MANAGEMENT:WRITE'],
								children: [
									ElementUtil.makeIcon('vaadin:plus', ' Add')
								],
								listeners: {
									click: function () {
										actionAddEdit();
									}
								}
							},
							{
								tag: 'dl-action-button',
								itemid: 'edit',
								'class': 'spacer-toolbar-item',
								disabled: true,
								permissions: ['TRACTOR_MANAGEMENT:WRITE'],
								children: [
									ElementUtil.makeIcon('vaadin:edit', ' Edit')
								],
								listeners: {
									click: function () {
										actionAddEdit(grid.selectedItems[0]);
									}
								}
							},
							{
								tag: 'div',
								style: 'float: right;',
								children: [
									{
										tag: 'dl-action-button',
										itemid: 'delete',
										theme: 'primary error',
										'class': 'spacer-toolbar-item',
										permissions: ['TRACTOR_MANAGEMENT:DELETE'],
										children: [
											ElementUtil.makeIcon('vaadin:trash', 'Delete')
										],
										listeners: {
											click: function () {
												actionDelete(grid.selectedItems[0]);
											}
										}
									}
								]
							}
						]
					});	
					
					var grid = ElementUtil.create({
						tag: 'vaadin-grid',
						theme: 'wrap-cell-content row-stripes column-borders',
						'column-reordering-allowed': '',
						style: 'height: 100%;',
						slot: 'primary',
						defaults: {
							tag: 'vaadin-grid-sort-column',
							resizable: true,
							listeners: {
								'direction-changed': function (event) {
									if (event.detail && event.detail.value) {
										grid.currentSortField = event.target.path;
										grid.currentSortDirection = event.detail.value.toUpperCase();										
									}
								}
							}
						},
						children: [							
							{
								path: 'stateProvCode',
								header: 'State/Province',
								width: '7em'
							},
							{
								path: 'countryCode',
								header: 'Country Code',
								width: '7em'
							},
							{
								path: 'registeredGvwrWeight',
								header: 'Registered GVWR Weight',
								width: '7em'
							},
							{
								path: 'weightUom',
								header: 'Weight UOM',
								width: '7em'
							}
						],
						listeners: {
							'active-item-changed': function (event) {
								const item = event.detail.value;
								grid.selectedItems = item ? [item] : [];
								if (grid.selectedItems.length > 0) {
									ElementUtil.query(toolbar, 'edit').disabled = false;
									ElementUtil.query(toolbar, 'delete').disabled = false;
								} else {
									ElementUtil.query(toolbar, 'edit').disabled = true;
									ElementUtil.query(toolbar, 'delete').disabled = true;
								}								
							}
						}
					});	
					
					var layout = ElementUtil.create({
						tag: 'dl-flex-layout',
						children: [	
							toolbar,
							grid
						]
					});	
					
					jurisWin.addToContentElement(layout);
				
					var actionRefresh = function() {
						
						UnitService.getTractorService().getTractorJurisdictions(options.tractor.tractorId).then(function(data){
							grid.activeItem = null;
							grid.items = data;	
						});
					
					};
					actionRefresh();
					
					var actionAddEdit = function(record) {
						var addEditWin = ElementUtil.create({
							tag: 'dl-dialog',
							title: (record ? 'Edit' : 'Add') + ' Jurisdiction',
							icon: 'vaadin:edit',				
							width: 450,
							height: 300,
							listeners: {
								ready: function() {						
									addEditWin.show();	
									
									var formPanel = ElementUtil.create({
										tag: 'dl-form-panel',
										itemid: 'form',
										children: [
											{
												tag: 'vaadin-form-layout',
												children: [													
													{
														tag: 'vaadin-combo-box',
														itemid: 'stateCB',
														label: 'License State/Province',
														name: 'stateProvCode',
														'item-value-path': 'code',
														'item-label-path': 'description',
														required: true,
														postinit: function (combo) {
															Service.getLookupService().getLookupValues('StateProvCode').then(function (data) {
																combo.items = data;
															});
														}
													},
													{
														tag: 'vaadin-number-field',
														name: 'registeredGvwrWeight',
														label: 'GVWR Weight',
														required: true,
														maxLength: 255
													},
													{
														tag: 'vaadin-combo-box',
														itemid: 'weightUom',
														label: 'Weight UOM',
														name: 'weightUom',
														'item-value-path': 'code',
														'item-label-path': 'description',
														value: 'LB',
														postinit: function (combo) {
															Service.getLookupService().getLookupValues('WeightUOM').then(function (data) {
																combo.items = data;
																combo.required = true;
															});
														}
													},
													{
														tag: 'hr',
														colspan: 2
													},
													{
														tag: 'div',
														style: 'text-align: center;',
														colspan: 2,
														defaults: {
															tag: 'vaadin-button'
														},
														children: [
															{
																theme: 'primary',
																children: [
																	ElementUtil.makeIcon('vaadin:database', ' Save')
																],
																listeners: {
																	click: function () {

																		formPanel.submitForm({
																			preSubmit: function (data) {
																				var countryCode = ElementUtil.query(formPanel, 'stateCB').selectedItem.country;
																				data.countryCode = countryCode;
																				return data;
																			},
																			actualCall: function (data) {
																				if (record) {
																					data.jurisdictionId = record.jurisdictionId;
																				}
																				data.tractorId = options.tractor.tractorId;
																				return UnitService.getTractorService().saveTractorJurisdiction(data, (record ? true : false));
																			},
																			success: function (data, responseData) {
																				window.DL.MessageUtil.showToast('Success', 'Saved Juridiction', {
																					theme: 'success',
																					position: 'top-stretch'
																				});
																				actionRefresh();
																				addEditWin.close();
																			}
																		});
																		
																	}
																}
															},
															{
																theme: 'tertiary',
																innerHTML: 'Cancel',
																style: 'margin-left: 10px;',
																listeners: {
																	click: function () {
																		//cancel
																		addEditWin.close();
																	}
																}
															}
														]
													}
												]
											}
										]
									});
									
									addEditWin.addToContentElement(formPanel);
									
									if (record) {
										formPanel.load(record);
									}
								}
							}
						});						
					};
					
					var actionDelete = function(record) {
						window.DL.MessageUtil.showConfirm({
							title: 'Confirm Delete',
							message: '<b>Are you sure you want to delete record?</b>',
							buttons: [
								{
									text: 'Yes',
									handler: function() {
										var loadMask = grid.showLoading('Removing...');

										UnitService.getTractorService().deleteTractorJurisdiction(options.tractor.tractorId, record.jurisdictionId).then(function(){
											loadMask.remove();
											window.DL.MessageUtil.showToast('Success', 'Successfully Removed Record', {
												theme: 'success'
											});
											actionRefresh();
										});				
									}
								},
								{
									text: 'No'
								}
							]
						});
						
					};
					
				}
			}
		});		
	},
	
	outOfAuthority: function(options) {
		var ooaWin = ElementUtil.create({
			tag: 'dl-dialog',
			title: 'Out of Authority',
			icon: 'vaadin:flag',				
			width: .75,
			height: .75,
			listeners: {
				ready: function() {						
					ooaWin.show();	
										
					var toolbar = ElementUtil.create({
						tag: 'dl-toolbar',
						slot: 'toolbar',
						theme: 'spacing',
						children: [							
							{
								tag: 'dl-action-button',
								itemid: 'add',
								theme: 'primary',
								'class': 'spacer-toolbar-item',
								permissions: ['TRACTOR_MANAGEMENT:WRITE'],
								children: [
									ElementUtil.makeIcon('vaadin:plus', ' Add')
								],
								listeners: {
									click: function () {
										actionAddEdit();
									}
								}
							},
							{
								tag: 'dl-action-button',
								itemid: 'edit',
								'class': 'spacer-toolbar-item',
								disabled: true,
								permissions: ['TRACTOR_MANAGEMENT:WRITE'],
								children: [
									ElementUtil.makeIcon('vaadin:edit', ' Edit')
								],
								listeners: {
									click: function () {
										actionAddEdit(grid.selectedItems[0]);
									}
								}
							},
							{
								tag: 'div',
								style: 'float: right;',
								children: [
									{
										tag: 'dl-action-button',
										itemid: 'delete',
										theme: 'primary error',
										'class': 'spacer-toolbar-item',
										permissions: ['TRACTOR_MANAGEMENT:DELETE'],
										children: [
											ElementUtil.makeIcon('vaadin:trash', 'Delete')
										],
										listeners: {
											click: function () {
												actionDelete(grid.selectedItems[0]);
											}
										}
									}
								]
							}
						]
					});	
					
					var grid = ElementUtil.create({
						tag: 'vaadin-grid',
						theme: 'wrap-cell-content row-stripes column-borders',
						'column-reordering-allowed': '',
						style: 'height: 100%;',
						slot: 'primary',
						defaults: {
							tag: 'vaadin-grid-sort-column',
							resizable: true,
							listeners: {
								'direction-changed': function (event) {
									if (event.detail && event.detail.value) {
										grid.currentSortField = event.target.path;
										grid.currentSortDirection = event.detail.value.toUpperCase();										
									}
								}
							}
						},
						children: [							
							{
								path: 'startDts',
								header: 'Start Dts',
								width: '7em',
								renderer: function (root, column, rowData) {
									if (rowData.item.startDts) {
										var date = TimeUtil.parseDate(rowData.item.startDts);
										root.innerHTML = TimeUtil.formatDateStandard(date);
									}
								}
							},
							{
								path: 'endDts',
								header: 'End Dts',
								width: '7em',
								renderer: function (root, column, rowData) {
									if (rowData.item.endDts) {
										var date = TimeUtil.parseDate(rowData.item.endDts);
										root.innerHTML = TimeUtil.formatDateStandard(date);
									}
								}
							},
							{
								path: 'outOfAuthorityTypeDescription',
								header: 'Type',
								width: '7em'
							},
							{
								path: 'comment',
								header: 'Comment',
								width: '9em'
							}
						],
						listeners: {
							'active-item-changed': function (event) {
								const item = event.detail.value;
								grid.selectedItems = item ? [item] : [];
								if (grid.selectedItems.length > 0) {
									ElementUtil.query(toolbar, 'edit').disabled = false;
									ElementUtil.query(toolbar, 'delete').disabled = false;
								} else {
									ElementUtil.query(toolbar, 'edit').disabled = true;
									ElementUtil.query(toolbar, 'delete').disabled = true;
								}								
							}
						}
					});	
					
					var layout = ElementUtil.create({
						tag: 'dl-flex-layout',
						children: [	
							toolbar,
							grid
						]
					});	
					
					ooaWin.addToContentElement(layout);
				
					var actionRefresh = function() {
						
						UnitService.getTractorService().getTractorOOAs(options.tractor.tractorId).then(function(data){
							grid.activeItem = null;
							grid.items = data;	
						});
					
					};
					actionRefresh();
					
					var actionAddEdit = function(record) {
						var addEditWin = ElementUtil.create({
							tag: 'dl-dialog',
							title: (record ? 'Edit' : 'Add') + ' Out of Authority',
							icon: 'vaadin:edit',				
							width: 600,
							height: 400,
							listeners: {
								ready: function() {						
									addEditWin.show();	
									
									var formPanel = ElementUtil.create({
										tag: 'dl-form-panel',
										itemid: 'form',
										children: [
											{
												tag: 'vaadin-form-layout',
												children: [													
													{
														tag: 'vaadin-combo-box',
														itemid: 'typeCB',
														label: 'Out of Authority Type',
														name: 'outOfAuthorityType',
														'item-value-path': 'code',
														'item-label-path': 'description',
														required: true,
														postinit: function (combo) {
															Service.getLookupService().getLookupValues('OutOfAuthorityType').then(function (data) {
																combo.items = data;
															});
														}
													},
													{
														tag: 'vaadin-date-time-picker',
														label: 'Start Date (mm/dd/yyyy hh:mm:ss)',
														name: 'startDts',
														step: 1,
														value: TimeUtil.formatDateForDateLoad(new Date()) + 'T00:00:00',
														required: true
													},
													{
														tag: 'vaadin-date-time-picker',
														label: 'End Date (mm/dd/yyyy hh:mm:ss)',
														name: 'endDts',
														step: 1
													},
													{
														tag: 'vaadin-text-field',
														name: 'comment',
														label: 'Comment',														
														maxLength: 1024
													},													
													{
														tag: 'hr',
														colspan: 2
													},
													{
														tag: 'div',
														style: 'text-align: center;',
														colspan: 2,
														defaults: {
															tag: 'vaadin-button'
														},
														children: [
															{
																theme: 'primary',
																children: [
																	ElementUtil.makeIcon('vaadin:database', ' Save')
																],
																listeners: {
																	click: function () {

																		formPanel.submitForm({
																			preSubmit: function (data) {
																				return data;
																			},
																			actualCall: function (data) {
																				if (record) {
																					data.outOfAuthorityId = record.outOfAuthorityId;
																				}
																				data.tractorId = options.tractor.tractorId;
																				return UnitService.getTractorService().saveTractorOOA(data, (record ? true : false));
																			},
																			success: function (data, responseData) {
																				window.DL.MessageUtil.showToast('Success', 'Saved Juridiction', {
																					theme: 'success',
																					position: 'top-stretch'
																				});
																				actionRefresh();
																				addEditWin.close();
																			}
																		});
																		
																	}
																}
															},
															{
																theme: 'tertiary',
																innerHTML: 'Cancel',
																style: 'margin-left: 10px;',
																listeners: {
																	click: function () {
																		//cancel
																		addEditWin.close();
																	}
																}
															}
														]
													}
												]
											}
										]
									});
									
									addEditWin.addToContentElement(formPanel);
									
									if (record) {
										formPanel.load(record);
									}
								}
							}
						});						
					};
					
					var actionDelete = function(record) {
						window.DL.MessageUtil.showConfirm({
							title: 'Confirm Delete',
							message: '<b>Are you sure you want to delete record?</b>',
							buttons: [
								{
									text: 'Yes',
									handler: function() {
										var loadMask = grid.showLoading('Removing...');

										UnitService.getTractorService().deleteTractorOOA(options.tractor.tractorId, record.outOfAuthorityId).then(function(){
											loadMask.remove();
											window.DL.MessageUtil.showToast('Success', 'Successfully Removed Record', {
												theme: 'success'
											});
											actionRefresh();
										});				
									}
								},
								{
									text: 'No'
								}
							]
						});
						
					};
					
				}
			}
		});
	},
	
	mpgOverrides: function(options) {		
		var mpgWin = ElementUtil.create({
			tag: 'dl-dialog',
			title: 'MPG Overrides',
			icon: 'vaadin:truck',				
			width: .75,
			height: .75,
			listeners: {
				ready: function() {						
					mpgWin.show();	
										
					var toolbar = ElementUtil.create({
						tag: 'dl-toolbar',
						slot: 'toolbar',
						theme: 'spacing',
						children: [							
							{
								tag: 'dl-action-button',
								itemid: 'add',
								theme: 'primary',
								'class': 'spacer-toolbar-item',
								permissions: ['TRACTOR_MANAGEMENT:WRITE'],
								children: [
									ElementUtil.makeIcon('vaadin:plus', ' Add')
								],
								listeners: {
									click: function () {
										actionAddEdit();
									}
								}
							},
							{
								tag: 'dl-action-button',
								itemid: 'edit',
								'class': 'spacer-toolbar-item',
								disabled: true,
								permissions: ['TRACTOR_MANAGEMENT:WRITE'],
								children: [
									ElementUtil.makeIcon('vaadin:edit', ' Edit')
								],
								listeners: {
									click: function () {
										actionAddEdit(grid.selectedItems[0]);
									}
								}
							},
							{
								tag: 'div',
								style: 'float: right;',
								children: [
									{
										tag: 'dl-action-button',
										itemid: 'delete',
										theme: 'primary error',
										'class': 'spacer-toolbar-item',
										permissions: ['TRACTOR_MANAGEMENT:DELETE'],
										children: [
											ElementUtil.makeIcon('vaadin:trash', 'Delete')
										],
										listeners: {
											click: function () {
												actionDelete(grid.selectedItems[0]);
											}
										}
									}
								]
							}
						]
					});	
					
					var grid = ElementUtil.create({
						tag: 'vaadin-grid',
						theme: 'wrap-cell-content row-stripes column-borders',
						'column-reordering-allowed': '',
						style: 'height: 100%;',
						slot: 'primary',
						defaults: {
							tag: 'vaadin-grid-sort-column',
							resizable: true,
							listeners: {
								'direction-changed': function (event) {
									if (event.detail && event.detail.value) {
										grid.currentSortField = event.target.path;
										grid.currentSortDirection = event.detail.value.toUpperCase();										
									}
								}
							}
						},
						children: [							
							{
								path: 'effectiveDts',
								header: 'Effective Dts',
								width: '7em',
								renderer: function (root, column, rowData) {
									if (rowData.item.effectiveDts) {
										var date = TimeUtil.parseDate(rowData.item.effectiveDts);
										root.innerHTML = TimeUtil.formatDateStandard(date);
									}
								}
							},							
							{
								path: 'mpgMinOverride',
								header: 'Min',
								width: '7em'
							},
							{
								path: 'mpgMinOverrideDefault',
								header: 'Min Default',
								width: '7em'
							},
							{
								path: 'mpgBetweenMinOverride',
								header: 'Between Min',
								width: '7em'
							},
							{
								path: 'mpgBetweenMaxOverride',
								header: 'Between Max',
								width: '7em'
							},
							{
								path: 'mpgBetweenOverrideDefault',
								header: 'Between Default',
								width: '7em'
							},
							{
								path: 'mpgMaxOverride',
								header: 'Max',
								width: '7em'
							},
							{
								path: 'mpgMaxOverrideDefault',
								header: 'Max Default',
								width: '7em'
							}
						],
						listeners: {
							'active-item-changed': function (event) {
								const item = event.detail.value;
								grid.selectedItems = item ? [item] : [];
								if (grid.selectedItems.length > 0) {
									ElementUtil.query(toolbar, 'edit').disabled = false;
									ElementUtil.query(toolbar, 'delete').disabled = false;
								} else {
									ElementUtil.query(toolbar, 'edit').disabled = true;
									ElementUtil.query(toolbar, 'delete').disabled = true;
								}								
							}
						}
					});	
					
					var layout = ElementUtil.create({
						tag: 'dl-flex-layout',
						children: [	
							toolbar,
							grid
						]
					});	
					
					mpgWin.addToContentElement(layout);
				
					var actionRefresh = function() {
						
						UnitService.getTractorService().getTractorMpgOverrides(options.tractor.tractorId).then(function(data){
							grid.activeItem = null;
							grid.items = data;	
						});
					
					};
					actionRefresh();
					
					var actionAddEdit = function(record) {
						var addEditWin = ElementUtil.create({
							tag: 'dl-dialog',
							title: (record ? 'Edit' : 'Add') + ' MPG Override',
							icon: 'vaadin:edit',				
							width: .65,
							height: .65,
							listeners: {
								ready: function() {						
									addEditWin.show();	
									
									var formPanel = ElementUtil.create({
										tag: 'dl-form-panel',
										itemid: 'form',
										children: [
											{
												tag: 'vaadin-form-layout',
												children: [																										
													{
														tag: 'vaadin-date-time-picker',
														label: 'Effective Date (mm/dd/yyyy hh:mm:ss)',
														name: 'effectiveDts',
														step: 1,
														value: TimeUtil.formatDateForDateLoad(new Date()) + 'T00:00:00',
														required: true
													},													
													{
														tag: 'vaadin-number-field',
														name: 'mpgMinOverride',
														label: 'Min',														
														min: 0,
														max: 99999
													},
													{
														tag: 'vaadin-number-field',
														name: 'mpgMinOverrideDefault',
														label: 'Min Default',														
														min: 0,
														max: 99999
													},
													{
														tag: 'vaadin-number-field',
														name: 'mpgBetweenMinOverride',
														label: 'Between Min',														
														min: 0,
														max: 99999
													},	
													{
														tag: 'vaadin-number-field',
														name: 'mpgBetweenMaxOverride',
														label: 'Between Max',														
														min: 0,
														max: 99999
													},
													{
														tag: 'vaadin-number-field',
														name: 'mpgBetweenOverrideDefault',
														label: 'Between Default',														
														min: 0,
														max: 99999
													},
													{
														tag: 'vaadin-number-field',
														name: 'mpgMaxOverride',
														label: 'Max',														
														min: 0,
														max: 99999
													},
													{
														tag: 'vaadin-number-field',
														name: 'mpgMaxOverrideDefault',
														label: 'Max Default',														
														min: 0,
														max: 99999
													},
													
													{
														tag: 'hr',
														colspan: 2
													},
													{
														tag: 'div',
														style: 'text-align: center;',
														colspan: 2,
														defaults: {
															tag: 'vaadin-button'
														},
														children: [
															{
																theme: 'primary',
																children: [
																	ElementUtil.makeIcon('vaadin:database', ' Save')
																],
																listeners: {
																	click: function () {

																		formPanel.submitForm({
																			preSubmit: function (data) {
																				return data;
																			},
																			actualCall: function (data) {
																				if (record) {
																					data.mpgOverrideId = record.mpgOverrideId;
																				}
																				data.tractorId = options.tractor.tractorId;
																				return UnitService.getTractorService().saveTractorMpgOverrides(data, (record ? true : false));
																			},
																			success: function (data, responseData) {
																				window.DL.MessageUtil.showToast('Success', 'Saved Juridiction', {
																					theme: 'success',
																					position: 'top-stretch'
																				});
																				actionRefresh();
																				addEditWin.close();
																			}
																		});
																		
																	}
																}
															},
															{
																theme: 'tertiary',
																innerHTML: 'Cancel',
																style: 'margin-left: 10px;',
																listeners: {
																	click: function () {
																		//cancel
																		addEditWin.close();
																	}
																}
															}
														]
													}
												]
											}
										]
									});
									
									addEditWin.addToContentElement(formPanel);
									
									if (record) {
										formPanel.load(record);
									}
								}
							}
						});						
					};
					
					var actionDelete = function(record) {
						window.DL.MessageUtil.showConfirm({
							title: 'Confirm Delete',
							message: '<b>Are you sure you want to delete record?</b>',
							buttons: [
								{
									text: 'Yes',
									handler: function() {
										var loadMask = grid.showLoading('Removing...');

										UnitService.getTractorService().deleteTractorMpgOverrides(options.tractor.tractorId, record.mpgOverrideId).then(function(){
											loadMask.remove();
											window.DL.MessageUtil.showToast('Success', 'Successfully Removed Record', {
												theme: 'success'
											});
											actionRefresh();
										});				
									}
								},
								{
									text: 'No'
								}
							]
						});
						
					};
					
				}
			}
		});
	},
	
	history: function(options) {
		var historyWin = ElementUtil.create({
			tag: 'dl-dialog',
			title: 'History',
			icon: 'vaadin:clock',				
			width: .75,
			height: .75,
			listeners: {
				ready: function() {						
					historyWin.show();	
										
					var toolbar = ElementUtil.create({
						tag: 'dl-toolbar',
						slot: 'toolbar',
						theme: 'spacing',
						children: [							
							{
								tag: 'dl-action-button',
								itemid: 'showChange',							
								'class': 'spacer-toolbar-item',
								permissions: ['TRACTOR_MANAGEMENT:READ'],
								children: [
									ElementUtil.makeIcon('vaadin:check', ' Show Changes')
								],
								listeners: {
									click: function () {
										actionShowChanges(grid.selectedItems[0]);
									}
								}
							},							
							{
								tag: 'div',
								style: 'float: right;',
								children: [
									{
										tag: 'dl-action-button',
										itemid: 'showNew',										
										'class': 'spacer-toolbar-item',
										permissions: ['TRACTOR_MANAGEMENT:READ'],
										children: [
											ElementUtil.makeIcon('vaadin:info-circle', ' Show State')
										],
										listeners: {
											click: function () {
												actionShowHistoryState(grid.selectedItems[0]);
											}
										}
									}
								]
							}
						]
					});	
					
					var grid = ElementUtil.create({
						tag: 'vaadin-grid',
						theme: 'wrap-cell-content row-stripes column-borders',
						'column-reordering-allowed': '',
						style: 'height: 100%;',
						slot: 'primary',
						defaults: {
							tag: 'vaadin-grid-sort-column',
							resizable: true,
							listeners: {
								'direction-changed': function (event) {
									if (event.detail && event.detail.value) {
										grid.currentSortField = event.target.path;
										grid.currentSortDirection = event.detail.value.toUpperCase();										
									}
								}
							}
						},
						children: [							
							{
								path: 'changeDate',
								header: 'Change Dts',
								width: '7em',
								direction: 'desc',
								renderer: function (root, column, rowData) {
									if (rowData.item.changeDate) {
										var date = TimeUtil.parseDate(rowData.item.changeDate);
										root.innerHTML = TimeUtil.formatDateStandard(date);
									}
								}
							}
						],
						listeners: {
							'active-item-changed': function (event) {
								const item = event.detail.value;
								grid.selectedItems = item ? [item] : [];
								if (grid.selectedItems.length > 0) {
									ElementUtil.query(toolbar, 'showChange').disabled = false;
									ElementUtil.query(toolbar, 'showNew').disabled = false;
								} else {
									ElementUtil.query(toolbar, 'showChange').disabled = true;
									ElementUtil.query(toolbar, 'showNew').disabled = true;
								}								
							}
						}
					});	
					
					var layout = ElementUtil.create({
						tag: 'dl-flex-layout',
						children: [	
							toolbar,
							grid
						]
					});	
					
					historyWin.addToContentElement(layout);
				
					var actionRefresh = function() {
						
						UnitService.getTractorService().getTractorHistory(options.tractor.tractorId).then(function(data){
							grid.activeItem = null;
							grid.items = data;	
						});
					
					};
					actionRefresh();
					
					var actionShowChanges = function(record) {
						var historyWin = ElementUtil.create({
							tag: 'dl-dialog',
							title: 'Details of Changes on ' + TimeUtil.formatDateStandard(record.changeDate),
							icon: 'vaadin:clock',
							width: .65,
							height: .65,
							listeners: {
								ready: function() {
									historyWin.show();
									
									var historyGrid = ElementUtil.create({
										tag: 'vaadin-grid',
										theme: 'wrap-cell-content row-stripes column-borders',
										'column-reordering-allowed': '',
										style: 'height: 100%;',
										slot: 'primary',
										defaults: {
											tag: 'vaadin-grid-sort-column',
											resizable: true,
											listeners: {
												'direction-changed': function (event) {													
												}
											}
										},
										children: [							
											{
												path: 'field',
												header: 'Field',
												width: '7em'
											},
											{
												path: 'oldValue',
												header: 'Old Value',
												width: '7em'
											},
											{
												path: 'newValue',
												header: 'New Value',
												width: '7em'
											}
										],
										listeners: {
											'active-item-changed': function (event) {
												const item = event.detail.value;
												historyGrid.selectedItems = item ? [item] : [];																		
											}
										}
									});	
									
									var historyLayout = ElementUtil.create({
										tag: 'dl-flex-layout',
										children: [											
											historyGrid
										]
									});

									historyWin.addToContentElement(historyLayout);
									
									var loadMask = historyGrid.showLoading();
									UnitService.getTractorService().getTractorHistoryDetail(options.tractor.tractorId, record.tractorHistoryId).then(function(history){
										loadMask.remove();
										
										//determine change fields										
										var changedFields = [];
										for (var key in history.oldTractor) {
											if (key === 'tanks') {
												var oldTanks = history.oldTractor[key];
												var newTanks = history.newTractor[key];
																							
												if (oldTanks && !newTanks) {
													oldTanks.forEach(function(tank){
														for (var keyTank in tank) {
															changedFields.push({
																field: 'Tank ' + tank.tankId + ' - ' + StringUtil.camelcaseToWord(keyTank),
																oldValue: tank[keyTank],
																newValue: ''
															});
														}
													});													
												} else if (!oldTanks && newTanks) {
													newTanks.forEach(function(tank){
														for (var keyTank in tank) {
															changedFields.push({
																field: 'Tank ' + tank.tankId + ' - ' + StringUtil.camelcaseToWord(keyTank),
																oldValue: '',
																newValue: tank[keyTank]
															});
														}
													});
												} else if (!oldTanks && !newTanks) {
													var oldTanksHash = {};
													oldTanks.forEach(function(tank){
														oldTanksHash[tank.tankId] = tank;
													});
													var newTanksHash = {};
													newTanks.forEach(function(tank){
														newTanksHash[tank.tankId] = tank;
													});
													
													//olds not in new tanks
													oldTanks.forEach(function(tank){
														if (!newTanksHash[tank.tankId]) {
															for (var keyTank in tank) {
																changedFields.push({
																	field: 'Tank ' + tank.tankId + ' - ' + StringUtil.camelcaseToWord(keyTank),
																	oldValue: tank[keyTank],
																	newValue: ''
																});
															}
														}
													});
													
													//tanks that matched (updated)
													oldTanks.forEach(function(oldTank){
														if (newTanksHash[oldTank.tankId]) {
															var newTank = newTanksHash[oldTank.tankId];
															var oldValues = {};
															for (var keyTank in oldTank) {
																oldValues[keyTank] = oldTank[keyTank];
															}
															for (var keyTank in newTank) {
																var oldValue = oldValues[keyTank];
																var newValue = newTank[keyTank];
																if (newValue !== oldValue) {
																	changedFields.push({
																		field: 'Tank ' + newTank.tankId + ' - ' + StringUtil.camelcaseToWord(key),
																		oldValue: oldValue,
																		newValue: newValue
																	});
																}
															}
														}	
													});
													
													//new tanks not in old tanks
													newTanks.forEach(function(tank){
														if (!oldTanksHash[tank.tankId]) {
															for (var keyTank in tank) {
																changedFields.push({
																	field: 'Tank ' + tank.tankId + ' - ' + StringUtil.camelcaseToWord(keyTank),
																	oldValue: '',
																	newValue: tank[keyTank]
																});
															}
														}
													});													
																										
												}
											} else if (key === 'tags') {
												
												var oldTags = history.oldTractor[key];
												var newTags = history.newTractor[key];
												
												var changed = false;
												if (oldTags && !newTags) {
													changed = true;
												} else if (!oldTags && newTags) {
													changed = true;
												} else if (!oldTags && !newTags) {
													var oldValues = {};
													oldTags.forEach(function(tag){
														oldValues[tag] = true;
													});
													newTags.forEach(function(tag){
														if (!oldValues[tag]) {
															changed = true;
														}
													});
												}
												
												if (changed) {
													changedFields.push({
														field: StringUtil.camelcaseToWord(key),
														oldValue: oldTags ? oldTags.join(', ') : '',
														newValue: newTags ? history.newTractor[key].join(', '): ''
													});
												}
											} else {
												if (history.oldTractor[key] !== history.newTractor[key]) {
													changedFields.push({
														field: StringUtil.camelcaseToWord(key),
														oldValue: history.oldTractor[key],
														newValue: history.newTractor[key]
													});
												}
											}											
										}
										changedFields.sort(function (a, b) {
											return a.field.localeCompare(b.field);
										});
										
										historyGrid.items = changedFields;
									});
									
								}
							}
						});	
					};
					
					var actionShowHistoryState = function(record) {
						var historyWin = ElementUtil.create({
							tag: 'dl-dialog',
							title: 'State of Tractor on ' + TimeUtil.formatDateStandard(record.changeDate),
							icon: 'vaadin:clock',
							width: .65,
							height: .65,
							listeners: {
								ready: function() {
									historyWin.show();
									
									var historyGrid = ElementUtil.create({
										tag: 'vaadin-grid',
										theme: 'wrap-cell-content row-stripes column-borders',
										'column-reordering-allowed': '',
										style: 'height: 100%;',
										slot: 'primary',
										defaults: {
											tag: 'vaadin-grid-sort-column',
											resizable: true,
											listeners: {
												'direction-changed': function (event) {													
												}
											}
										},
										children: [							
											{
												path: 'field',
												header: 'Field',
												width: '7em'
											},
											{
												path: 'value',
												header: 'Value',
												width: '7em'
											}
										],
										listeners: {
											'active-item-changed': function (event) {
												const item = event.detail.value;
												historyGrid.selectedItems = item ? [item] : [];																		
											}
										}
									});	
									
									var historyLayout = ElementUtil.create({
										tag: 'dl-flex-layout',
										children: [											
											historyGrid
										]
									});

									historyWin.addToContentElement(historyLayout);
									
									var loadMask = historyGrid.showLoading();
									UnitService.getTractorService().getTractorHistoryDetail(options.tractor.tractorId, record.tractorHistoryId).then(function(history){
										loadMask.remove();
										
										var details = convertTractorToDetails(history.newTractor);
									
										historyGrid.items = details;
									});
									
								}
							}
						});
					};
							
					var convertTractorToDetails = function(tractor) {
						var details = [];
						for (var key in tractor) {
							if (key === 'tanks') {								
								tractor.tanks.forEach(function(tank){
									for (var keyTank in tank) {
										details.push({
											field: 'Tank ' + tank.tankId + ' - ' + StringUtil.camelcaseToWord(keyTank),
											value: tank[keyTank]
										});	
									}									
								});
															
							} else if (key === 'tags') {
								details.push({
									field: 'Tags',
									value: tractor.tags.join(', ')
								});
							} else {
								details.push({
									field: StringUtil.camelcaseToWord(key),
									value: tractor[key]
								});	
							}
						}
						details.sort(function(a, b) {
							return a.field.localeCompare(b.field);
						});
						
						return details;
					};					
					
				}
			}
		});
	},
	
	quickFlag: function(options) {
		var flagWin = ElementUtil.create({
			tag: 'dl-dialog',
			title: 'Quick Flag',
			icon: 'vaadin:flag',				
			width: 500,
			height: 250,
			listeners: {
				ready: function() {						
					flagWin.show();	
					
					var formPanel = ElementUtil.create({
						tag: 'dl-form-panel',
						itemid: 'form',
						children: [
							{
								tag: 'vaadin-form-layout',
								children: [
									{
										tag: 'vaadin-combo-box',
										itemid: 'typeCB',
										label: 'Type',
										name: 'tractorFlagType',
										'item-value-path': 'code',
										'item-label-path': 'description',
										required: true,
										postinit: function (combo) {
											Service.getLookupService().getLookupValues('TractorFlagType').then(function (data) {
												combo.items = data;
											});
										}, 
										listeners: {
											change: function() {
												var typeValue = ElementUtil.query(formPanel, 'typeCB').value;
												
												if (typeValue === 'ADD_TAGS' || typeValue === 'REMOVE_TAGS') {
													ElementUtil.query(formPanel, 'valueTags').classList.remove('hide');
												} else {
													ElementUtil.query(formPanel, 'valueTags').classList.add('hide');
												}
												
												if (typeValue === 'DO_NOT_USE_TOLL_MILES' || 
													typeValue === 'FUEL_TAX_EXEMPT_FLAG' ||
													typeValue === 'SECURE_FUEL' ||
													typeValue === 'TRUCK_FLAG') {
													ElementUtil.query(formPanel, 'valueCHK').classList.remove('hide');
												} else {
													ElementUtil.query(formPanel, 'valueCHK').classList.add('hide');
												}
												
												if (typeValue === 'EQUIPMENT_OWNERSHIP') {
													ElementUtil.query(formPanel, 'ownershipTypeCB').classList.remove('hide');
												} else {
													ElementUtil.query(formPanel, 'ownershipTypeCB').classList.add('hide');
												}
												
												if (typeValue === 'HAUL_TYPE') {
													ElementUtil.query(formPanel, 'haulTypeCB').classList.remove('hide');
												} else {
													ElementUtil.query(formPanel, 'haulTypeCB').classList.add('hide');
												}
											}
										}										
									},
									{
										tag: 'vaadin-checkbox',
										itemid: 'valueCHK',
										name: 'checkValue',
										'class': 'hide',										
										label: 'Update Value'
									},
									{										
										tag: 'div',
										children: [
											{
												tag: 'vaadin-combo-box',
												itemid: 'haulTypeCB',
												'class': 'hide',
												style: 'width: 100%',
												label: 'Haul Type',
												name: 'haulValue',
												'item-value-path': 'code',
												'item-label-path': 'description',										
												postinit: function (combo) {
													Service.getLookupService().getLookupValues('HaulType').then(function (data) {
														combo.items = data;
													});
												}
											}
										]
									},
									{										
										tag: 'div',
										children: [
											{
												tag: 'vaadin-combo-box',
												itemid: 'ownershipTypeCB',
												'class': 'hide',
												style: 'width: 100%',
												label: 'Ownership type',
												name: 'ownerShipValue',
												'item-value-path': 'code',
												'item-label-path': 'description',										
												postinit: function (combo) {
													Service.getLookupService().getLookupValues('EquipmentOwnershipType').then(function (data) {
														combo.items = data;
													});
												}
											}
										]
									},
									{										
										tag: 'div',
										children: [
											{
												tag: 'dl-tagfield',
												itemid: 'valueTags',
												name: 'tagValue',
												'class': 'hide',
												label: 'Tags',
												maxLength: 80
											}
										]
									},
									{
										tag: 'hr',
										colspan: 2
									},
									{
										tag: 'div',
										style: 'text-align: center;',
										colspan: 2,
										defaults: {
											tag: 'vaadin-button'
										},
										children: [
											{
												theme: 'primary',
												children: [
													ElementUtil.makeIcon('vaadin:database', ' Save')
												],
												listeners: {
													click: function () {

														formPanel.submitForm({
															preSubmit: function (data) {
																var typeValue = ElementUtil.query(formPanel, 'typeCB').value;
																if (typeValue === 'ADD_TAGS' || typeValue === 'REMOVE_TAGS') {
																	data.value = data.tagValue.join(',');
																} 

																if (typeValue === 'DO_NOT_USE_TOLL_MILES' || 
																	typeValue === 'FUEL_TAX_EXEMPT_FLAG' ||
																	typeValue === 'SECURE_FUEL' ||
																	typeValue === 'TRUCK_FLAG') {
																	data.value = data.checkValue;
																} 

																if (typeValue === 'EQUIPMENT_OWNERSHIP') {
																	data.value = data.ownerShipValue;
																} 

																if (typeValue === 'HAUL_TYPE') {
																	data.value = data.haulValue;
																} 
																data.tractorIds = {
																	ids: []
																};
																options.tractors.forEach(function (tractor) {
																	data.tractorIds.ids.push(tractor.tractorId);
																});																
																return data;
															},
															actualCall: function (data) {																
																return UnitService.getTractorService().flagTractor(data);
															},
															success: function (data, responseData) {
																window.DL.MessageUtil.showToast('Success', 'Updated Tractors', {
																	theme: 'success',
																	position: 'top-stretch'
																});
																if (options.successCallback) {
																	options.successCallback();
																}																
																flagWin.close();
															}
														});

													}
												}
											},
											{
												theme: 'tertiary',
												innerHTML: 'Cancel',
												style: 'margin-left: 10px;',
												listeners: {
													click: function () {
														//cancel
														flagWin.close();
													}
												}
											}
										]
									}
								]
							}
						]
					});

					flagWin.addToContentElement(formPanel);					
					
				}
			}
		});
	}
	
};


